import React from 'react'
import { ApolloProvider } from 'react-apollo'
import {
  Router, Route, Switch,
} from 'react-router-dom'
import client from './apollo-client'
import history from './history'
import Container from './components/container'
import Landing from './pages/landing'
import { ForgotPasswordSection, ResetSection } from './pages/login/reset-password'
import Profile from './pages/profile'
import Login from './pages/login'
import NotFound from './pages/not-found-page'
import ReserveStep from './pages/reserve'

const App = () => (
  <ApolloProvider client={client}>
    <Router history={history}>
      <Switch>
        <Route path='/login' exact component={Login}/>
        <Route path='/profile' exact component={Profile}/>
        <Route path='/forgot-password' exact component={ForgotPasswordSection}/>
        <Route path='/reset-password/:token' exact component={ResetSection}/>
        <Container>
          <Switch>
            <Route path='/' exact component={ReserveStep}/>
            <Route component={NotFound}/>
          </Switch>
        </Container>
      </Switch>
    </Router>
  </ApolloProvider>
)


export default App



// WEBPACK FOOTER //
// ./src/app.js